import { gql } from "@codesandbox/api";

import { useCsbApi } from "./useCsbApi";

type Props = {
  branchId: string;
  protected: boolean;
};

const query = gql.createMutation("setBranchProtection", (props: Props) => ({
  setBranchProtection: [props, { id: true }],
}));

export const useSetBranchProtection = () => {
  const csbApi = useCsbApi();
  return (props: Props) => {
    return csbApi.gql.query(query, props);
  };
};
